import { Link } from '@tkww/orion-web-ds-action';
import { Icon } from '@tkww/orion-web-ds-graphic';
import { TextBody } from '@tkww/orion-web-ds-text';
import React, { type FC } from 'react';
import Styles from './styles.scss';

export type AfterReviewProps = {
	alignment: 'left' | 'center' | 'left-small';
	border: 'none' | 'partial' | 'full';
	mobileBorder: 'none' | 'partial' | 'full';
};

const borderClass = (props: AfterReviewProps) => {
	switch (props.border) {
		case 'none':
			return '';

		case 'full':
			return Styles.fullBorder;

		case 'partial':
			return Styles.partialBorder;

		default:
			return '';
	}
};

const mobileBorderClass = (props: AfterReviewProps) => {
	switch (props.mobileBorder) {
		case 'none':
			return '';

		case 'full':
			return Styles.fullBorderMobile;

		case 'partial':
			return Styles.partialBorderMobile;

		default:
			return '';
	}
};

const ReviewVendorsLink: FC = () => {
	const uri = '/review-wedding-vendors';
	const label = 'Manage your vendor reviews';

	const link = (
		<Link href={uri} aria-label={label}>
			here
		</Link>
	);

	return (
		<TextBody size="md" color="subtle-dark">
			<span>You can manage your vendor reviews </span>
			<span className={Styles.noWrap}>{link}.</span>
		</TextBody>
	);
};

const AfterReviewLeft: FC<AfterReviewProps> = (props) => (
	<div className={`${borderClass(props)} ${mobileBorderClass(props)}`}>
		<div className={Styles.content}>
			<div className={Styles.header}>
				<Icon
					size="md"
					color="success"
					name="check-circle-filled"
					aria-label={undefined}
					aria-hidden={true}
				/>

				<TextBody size="xl" bold>
					Thank you!
				</TextBody>
			</div>

			<TextBody size="md" bold>
				Your review has been published.
			</TextBody>

			<ReviewVendorsLink />
		</div>
	</div>
);

const AfterReviewCenter: FC<AfterReviewProps> = (props) => (
	<div className={`${borderClass(props)} ${mobileBorderClass(props)}`}>
		<div className={`${Styles.content} ${Styles.center}`}>
			<Icon
				size="lg"
				color="success"
				name="check-circle-filled"
				aria-label={undefined}
				aria-hidden={true}
			/>

			<TextBody size="xl" bold>
				Thank you! Your review has been published.
			</TextBody>

			<ReviewVendorsLink />
		</div>
	</div>
);

const AfterReviewLeftSmall: FC<AfterReviewProps> = (props) => (
	<div className={`${borderClass(props)} ${mobileBorderClass(props)}`}>
		<div className={Styles.content}>
			<div className={Styles.header}>
				<Icon
					size="md"
					color="success"
					name="check-circle-filled"
					aria-label={undefined}
					aria-hidden={true}
				/>

				<TextBody size="lg" bold>
					Your review has been published.
				</TextBody>
			</div>

			<ReviewVendorsLink />
		</div>
	</div>
);

export const AfterReview: FC<AfterReviewProps> = (props) => {
	switch (props.alignment) {
		case 'left':
			return <AfterReviewLeft {...props} />;

		case 'center':
			return <AfterReviewCenter {...props} />;

		case 'left-small':
			return <AfterReviewLeftSmall {...props} />;

		default:
			return <AfterReviewLeft {...props} />;
	}
};
